module.exports = __webpack_public_path__ + "media/12_23.a1f60d1d.wav";